/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import { StepBody, StepFooter, useInput } from "meitav-uikit";
import Otp from "components/Otp/Otp";
import { Parser } from "html-to-react";
import Footer from "components/Footer";

import "./Step11.scss";
import { saveModel } from "../../../../../utils/Functions";
import { popupWin } from "components/PopUps";
const { UmbracoUtills, rest } = utils;

export default function Step11({
  resource,
  model,
  recapchaKey,
  setModel,
  nextText,

  setStep,
  step,
  resourceError,
}) {
  const p = new Parser();

  const resourceStep = UmbracoStep(resource, `PopUpOtp`);
  const otpValue = useInput("", "");
  const [blocked, setBlocked] = useState(false);
  const [message, setMessage] = useState("");

  const [disable, setDisable] = useState(false);
  const [popupObj, setPopupObj] = useState("");
  const [objExistingProcess, setObjExistingProcess] = useState("");

  /*useEffect(() => {
    if (otpValue.value !=undefined && otpValue.value.length == 5) handleSubmitOtp();
    }
, [otpValue.value]); */

  useEffect(() => {
    let obj = {};
    obj.type = "message";
    obj.handleClose = handleCloseInvalidOtp;
    obj.specialText = p.parse(
      UmbracoUtills.getValueByKey(resourceStep, "invalidOtpTriedLimit")
    );
    setPopupObj(obj);

    let objExisting = {};
    objExisting.type = "existingProcess";
    objExisting.resource = resource;
    objExisting.buttonClick = true;
    objExisting.className = "existingProcess";
    objExisting.hideClose = true;
    objExisting.riskLevelName = model.riskLevelName;
    objExisting.riskLevel = model.riskLevel;
    objExisting.sectorName = model.sectorName;
    objExisting.handleCick = handleCickExistingProcess;
    setObjExistingProcess(objExisting);
  }, []);
  const handleCickExistingProcess = (isJoinInvestPolicyOld) => {
    const tmpModel = model;
    tmpModel.isJoinInvestPolicyOld = isJoinInvestPolicyOld;
    if (isJoinInvestPolicyOld == "false") {
      rest
        .post("/api/Manager/ExitingProcessUpdate", {
          data: model,
        })
        .then((res) => {});
      tmpModel.sectorCode = tmpModel.sectorCodeFirst;
      tmpModel.riskLevelName = "";
      tmpModel.riskLevel = "";
      tmpModel.sectorName = "";
    }
    saveModel(tmpModel, model.existingProcessStep);
    setStep(tmpModel.existingProcessStep);
    window.popupClose();
  };
  const handleCloseInvalidOtp = () => {
    localStorage.removeItem("model");
    localStorage.removeItem("processGuid");
    localStorage.removeItem("otpGuid");

    window.location.href = "/CustomerInvestPolicy";
  };
  const handleCick = () => {
    newprocess();
  };
  const newprocess = () => {
    const tmpModel = model;
    tmpModel.isExistingCustomer = false;

    tmpModel.mainUser.depositSum = "";
    tmpModel.mainUser.firstName = "";
    tmpModel.mainUser.lastName = "";
    tmpModel.mainUser.email = "";
    tmpModel.mainUser.iDNumber = "";
    setStep(10);
    tmpModel.stepID = 10;
    saveModel(tmpModel, 10);
    localStorage.setItem("otpGuid", "");
  };

  const handleNext = async () => {
    if (otpValue.value.length == 6) handleSubmitOtp();
  };

  function handleSubmitOtp() {
    const otpGuid =
      localStorage.getItem("otpGuid") &&
      localStorage.getItem("otpGuid") != "undefined"
        ? localStorage.getItem("otpGuid")
        : null;

    return new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        alert("Recaptcha non definito");
        reject();
      }
      grecaptcha.enterprise
        .execute(recapchaKey, {
          action: "ConfirmPassword",
        })
        .then(function (token) {
          rest
            .get(
              `/api/manager/ConfirmPassword?otpCode=${otpValue.value}&otpGuid=${otpGuid}`,
              {
                headers: {
                  gCaptcha: token,
                  action: "ConfirmPassword",
                },
              }
            )
            .then((result) => {
              if (result?.data === "") {
                const tmpModel = model;
                if (tmpModel.isExistingProcess) {
                  tmpModel.stepID = tmpModel.existingProcessStep;
                  setStep(tmpModel.existingProcessStep);
                  saveModel(tmpModel, tmpModel.existingProcessStep);
                  popupWin(objExistingProcess);
                }
                setStep(21);
                tmpModel.stepID = 21;
                saveModel(tmpModel, 21);
              } else {
                otpValue.setValue("");
                setMessage(result?.data);
                if (result?.data === "invalidOtpTriedLimit") {
                  setBlocked(true);
                  //setMessage(result?.data);
                  popupWin(popupObj);
                }
              }
            });
        });
    });
  }

  return (
    <div className="step11">
      <StepBody>
        <Otp
          otpValue={otpValue}
          recapchaKey={recapchaKey}
          resourceError={resourceStep}
          handleCick={handleCick}
          textIcon={UmbracoUtills.getValueByKey(resourceStep, "icon")}
          textTitle={UmbracoUtills.getValueByKey(resourceStep, "title")}
          textDescription={UmbracoUtills.getValueByKey(
            resourceStep,
            "sendAgain"
          )}
          blocked={blocked}
          handleSubmitOtp={handleSubmitOtp}
          subTitle={UmbracoUtills.getValueByKey(resourceStep, "subTitle")}
          message={message}
          setMessage={setMessage}
        ></Otp>
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        isPrevHiden={true}
        isNextDisabled={disable}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </div>
  );
}
